export const PermissionAction = {
  LIST: 'list',
  READ: 'read',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  WRITE: 'write',
} as const;

export type PermissionAction =
  (typeof PermissionAction)[keyof typeof PermissionAction];

export type Permission = {
  permission: string;
  action: PermissionAction;
};

export type RoleSummary = {
  id: string;
  name: string;
  description?: string;
};

export type GetPermissionsResponse = {
  role?: RoleSummary | null;
  permissions: Permission[];
};
